module.exports = __webpack_public_path__ + "static/alk-logo-29df5c8c4975878f67d24e725b9807ad.svg";